import React from 'react';
import { FormField, FormHelp, Label } from '@zillow/constellation-10';

import type { Section } from '../../../models';
import { PRODUCTION_DISTRIBUTION_REPAIR } from '../../../constants';
import YesAndNo from '../../../components/Widgets/YesAndNo';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

function ProductionDistributionRepair({ section, setSectionValues }: Props) {
  function onNoPDR(): void {
    setSectionValues({
      [PRODUCTION_DISTRIBUTION_REPAIR.FIELD_NAME.IS_ENABLED]: false,
    });
  }

  function onYesPDR(): void {
    setSectionValues({
      [PRODUCTION_DISTRIBUTION_REPAIR.FIELD_NAME.IS_ENABLED]: true,
    });
  }

  return (
    <FormField
      required
      label={
        <Label>
          Is the property located in an area that permits Production, Distribution, and Repair (PDR) uses, which could
          subject a tenant to certain inconveniences or discomforts?
        </Label>
      }
      description={
        <FormHelp>
          PDR is defined in Planning Code Section 102 and may subject the renter to inconveniences or discomforts which
          include noise, odors, dust, chemicals, smoke, operation of machinery, and loading and unloading operations,
          which may occur throughout the day and night. A grouping of uses that includes, but is not limited, to all
          industrial and agricultural uses, ambulance services, animal hospital, automotive service station, automotive
          repair, automotive wash, arts activities, business services, cat boarding, catering, commercial storage,
          kennel, motor vehicle tow service, livery stable, parcel delivery service, public utilities yard, storage
          yard, trade office, trade shop, wholesale sales, and wholesale storage.
        </FormHelp>
      }
      control={
        <YesAndNo
          yesHandler={onYesPDR}
          noHandler={onNoPDR}
          yesActive={section.getFieldValue(PRODUCTION_DISTRIBUTION_REPAIR.FIELD_NAME.IS_ENABLED)}
        />
      }
    />
  );
}

ProductionDistributionRepair.description = 'Asks whether or not the property is in an area that permits PDR.';

export default ProductionDistributionRepair;
